export const nonSpecialChars = /^[a-zA-ZÀ-ÿ\u00f1\u00d10-9 ]*$/;
export const alphaNum = /^[a-zA-Z0-9]*$/;
export const nonEmptySpecialCharsDashes =
  /^[a-zA-ZÀ-ÿ\u00f1\u00d10-9 \-_]*[a-zA-ZÀ-ÿ\u00f1\u00d10-9\-_]+ ?$/;
export const nonSpecialCharsStr = '[a-zA-ZÀ-ÿ\u00f1\u00d10-9 ]*';
export const onlyNumbers = /^\d*$/;
export const onlyNumbersAndPoint = /^[0-9]+([.][0-9]+)*?$/;
export const onlyString = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/;
export const email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const nonNumbers = /\D/g;
export const nonDecimals = /[^0-9.,]/g;
export const regex_documents = /^[A-Za-z0-9-]+$/;
export const nonWordChars = /[^\w\s-]/g;
export const nonChars = /[^a-zA-ZÀ-ÿ\u00f1\u00d10-9 ]/g;
export const nonCharsDashes = /[^a-zA-ZÀ-ÿ\u00f1\u00d10-9 \-_]/g;
export const nonSpecialCharsExceptDashesLineJumps =
  /[^a-zA-ZÀ-ÿ\u00f1\u00d10-9 \-_\n]/g;
export const nonSpecialCharsDashes = /^[a-zA-ZÀ-ÿ\u00f1\u00d10-9 \-_]*$/;
export const url =
  /^https?:\/\/w{0,3}\w*?\.(\w*?\.)?\w{2,3}\S*|www\.(\w*?\.)?\w*?\.\w{2,3}\S*|(\w*?\.)?\w*?\.\w{2,3}[/?]\S*$/;
export const nonSpecialCharsWithSpaceWithoutline =
  /[^a-zA-ZÀ-ÿ\u00f1\u00d10-9_]*$/g;
export const nonSpecialCharsWithoutSpaceWithline =
  /^[a-zA-ZÀ-ÿ\u00f1\u00d10-9_]*$/;
export const nonSpecialCharsWithSpaceWithoutDash = /[^a-zA-Z0-9-]*$/g;
export const nonSpecialCharsWithoutSpaceWithDash = /^[a-zA-Z0-9-]*$/;
export const forOperations =
  /[^a-zA-ZÀ-ÿ\u00f1\u00d10-9+-/*<>=_()%.{}[\]"\s]*[^a-zA-ZÀ-ÿ\u00f1\u00d10-9+-/*<>=_()%.{}[\] "]+ ?/g;
export const withoutOperations =
  /^[a-zA-ZÀ-ÿ\u00f1\u00d10-9+-/*<>=()%.{}[\]"\s_]*[a-zA-ZÀ-ÿ\u00f1\u00d10-9+-/*<>=()%.{}[\]_"]+ ?$/;
export const nameAdditionalFields = /[^a-zA-Z0-9-_.#\s]*[^a-zA-Z0-9-_.]+ ?$/g; //No puede tener un solo espacio y tiene esos símbolos
export const nonNameAdditionalFields =
  /^[a-zA-Z0-9-_./#\s]*[a-zA-Z0-9-_/.]+ ?$/; //No puede tener un solo espacio y tiene esos símbolos
export const nonEmptySpecialCharsDashesWithLine = /^[A-Za-z_][A-Za-z0-9_]*$/;
export const nonEmptySpecialCharsDashesWithPointAndLine =
  /^([A-Za-z_][A-Za-z0-9_]*\.?)*[A-Za-z_][A-Za-z0-9_]*$/;
export const noEmail = /[^@.A-Za-z0-9_-]/g;
export const nonEmptySpecialChars =
  /^[a-zA-ZÀ-ÿ\u00f1\u00d10-9 \-_., ]*[a-zA-ZÀ-ÿ\u00f1\u00d10-9\-_., ]+ ?$/;
export const nonPointsCharsDashes = /[^a-zA-ZÀ-ÿ\u00f1\u00d10-9 \-_.,]/g;
export const fileNameRgx = /^[A-Za-z0-9_-]+\.[a-z]{1,5}$/;
